/**
 * @fileoverview A hook that provides functions to open and close a modal.
 *
 * @example
 * const [openModal, closeModal] = useModal();
 * openModal({ title: 'My Modal', content: 'This is the content of my modal' });
 * closeModal();
 */

import { useContext } from 'react'
import { ModalConfig, ModalContext } from '../components/modals/Context'

/**
 * @function useModal
 * @description Hook to open and close a modal.
 * @returns {[(config: ModalConfig) => void, () => void]} - Functions to open and close the modal.
 */
export function useModal(): [(config: ModalConfig) => void, () => void] {
    const modal = useContext(ModalContext)
    return [modal.open, modal.close]
}
